import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
var LoaderService = /** @class */ (function () {
    function LoaderService(document) {
        this.document = document;
        this.loader = this.document.getElementById('hansel-loader');
    }
    LoaderService.prototype.display = function (selector, notScrollToTop) {
        this.loader = document.querySelector(selector ? selector : '#hansel-loader');
        var scrollView = document.querySelector((selector && selector !== '#hansel-loader-full') ? selector : '.topmost-container');
        if (this.loader && scrollView) {
            if (!notScrollToTop) {
                scrollView.scrollIntoView();
            }
            this.disableScroll();
            this.loader.style.display = 'block';
        }
    };
    LoaderService.prototype.hide = function (selector) {
        this.loader = document.querySelector(selector ? selector : '#hansel-loader');
        if (this.loader) {
            this.loader.style.display = 'none';
        }
        this.enableScroll();
    };
    LoaderService.prototype.preventDefault = function (e) {
        e = e || window.event;
        if (e.preventDefault) {
            e.preventDefault();
        }
        e.returnValue = false;
    };
    LoaderService.prototype.disableScroll = function () {
        if (window.addEventListener) { // older FF
            window.addEventListener('DOMMouseScroll', this.preventDefault, { passive: false });
        }
        document.addEventListener('wheel', this.preventDefault, { passive: false }); // Disable scrolling in Chrome
        window.onwheel = this.preventDefault; // modern standard
        // window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
        window.ontouchmove = this.preventDefault; // mobile
        document.onkeydown = this.preventDefault;
    };
    LoaderService.prototype.enableScroll = function () {
        if (window.removeEventListener) {
            window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
        }
        document.removeEventListener('wheel', this.preventDefault, false); // Enable scrolling in Chrome
        // window.onmousewheel = document.onmousewheel = null;
        window.onwheel = null;
        window.ontouchmove = null;
        document.onkeydown = null;
    };
    LoaderService.ngInjectableDef = i0.defineInjectable({ factory: function LoaderService_Factory() { return new LoaderService(i0.inject(i1.DOCUMENT)); }, token: LoaderService, providedIn: "root" });
    return LoaderService;
}());
export { LoaderService };
